import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import Vue from 'vue';
import VueRouter from 'vue-router'; // 进度条

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import store from '@/store/index';
import util from '@/libs/util.js'; // 路由数据

import routes from './routes';
import { cloneDeep } from 'lodash';
import { Message } from 'element-ui'; // fix vue-router NavigationDuplicated

var VueRouterPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return VueRouterPush.call(this, location).catch(function (err) {
    return err;
  });
};

var VueRouterReplace = VueRouter.prototype.replace;

VueRouter.prototype.replace = function replace(location) {
  return VueRouterReplace.call(this, location).catch(function (err) {
    return err;
  });
};

Vue.use(VueRouter); // 导出路由 在 main.js 里使用

var router = new VueRouter({
  routes: routes
});
/**
 * 路由拦截
 * 权限验证
 */

router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var locationHost, users, index, token, routes, accessRoutes, sRoute, i1, i2, i3;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // console.log('to',to);
            // console.log(util.cookies.get('userApi'))
            if (!util.cookies.get('businessAPI')) {
              locationHost = location.hostname;
              users = process.env.VUE_APP_API_USERS.split(',');
              index = users.findIndex(function (v) {
                return v.includes(locationHost);
              });

              if (index !== -1) {
                // util.cookies.set('businessAPI', users[index])
                if (locationHost === 'localhost') {
                  util.cookies.set('businessAPI', users[0]);
                } else {
                  util.cookies.set('businessAPI', users[index]);
                }
              } else {
                if (!util.cookies.get('businessAPI')) {
                  util.cookies.set('businessAPI', users[0]);
                }
              }
            } // 获取api地址


            _context.next = 3;
            return store.dispatch('custom/apiConfig/asyncApiPath', util.cookies.get('businessAPI'));

          case 3:
            _context.next = 5;
            return store.dispatch('d2admin/page/isLoaded');

          case 5:
            _context.next = 7;
            return store.dispatch('d2admin/size/isLoaded');

          case 7:
            // 进度条
            NProgress.start(); // 关闭搜索面板

            store.commit('d2admin/search/set', false);
            token = util.cookies.get('token');
            routes = store.getters.roleMenu; // console.log('token',token);
            // console.log('routes------',routes);
            // 验证当前路由所有的匹配中是否需要有登录验证的

            if (!to.matched.some(function (r) {
              return r.meta.auth;
            })) {
              _context.next = 56;
              break;
            }

            if (!(token && token !== 'undefined')) {
              _context.next = 51;
              break;
            }

            if (!routes.length) {
              _context.next = 17;
              break;
            }

            next();
            _context.next = 49;
            break;

          case 17:
            _context.prev = 17;
            _context.next = 20;
            return store.dispatch('custom/permission/getOrgInfo');

          case 20:
            _context.next = 22;
            return store.dispatch('d2admin/user/generateRoutes', store.getters.roleId);

          case 22:
            accessRoutes = _context.sent;
            console.log('accessRoutes', accessRoutes); // API 获取按钮权限

            _context.next = 26;
            return store.dispatch('custom/permission/getBtnList');

          case 26:
            sRoute = serializationRoutesData(accessRoutes); // console.log('sRoute', sRoute)
            // 删除一级中的高级查询

            i1 = sRoute.findIndex(function (v) {
              return v.title.includes('高级查询权限');
            }); // console.log('i1',i1);

            if (i1 !== -1) {
              sRoute.splice(i1, 1);
            } // 删除系统管理中的高级查询


            i2 = sRoute.findIndex(function (v) {
              return v.title.includes('系统管理');
            });

            if (i2 !== -1) {
              i3 = sRoute[i2].children.findIndex(function (v) {
                return v.title.includes('高级查询权限');
              });

              if (i3 !== -1) {
                sRoute[i2].children.splice(i3, 1);
              }
            }

            store.dispatch('d2admin/router/setRouters', sRoute);
            store.commit('d2admin/menu/asideSet', sRoute);
            store.commit('d2admin/search/init', sRoute);

            if (accessRoutes.length) {
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            } else {
              util.cookies.remove('token');
              util.cookies.remove('userInfo');
              util.cookies.remove('ORG_CODE');
              next({
                name: 'login'
              });
              NProgress.done();
            }

            _context.next = 49;
            break;

          case 37:
            _context.prev = 37;
            _context.t0 = _context["catch"](17);
            NProgress.done(); // console.log(error.message)
            // 删除cookie

            util.cookies.remove('token');
            util.cookies.remove('userInfo');
            util.cookies.remove('ORG_CODE'); // 路由

            store.dispatch('d2admin/router/setRouters', []);
            store.commit('d2admin/menu/asideSet', []); // 清空 vuex 用户信息

            _context.next = 47;
            return store.dispatch('d2admin/user/set', {}, {
              root: true
            });

          case 47:
            Message.error(_context.t0.message);
            next("/login?redirect=".concat(to.fullPath));

          case 49:
            _context.next = 53;
            break;

          case 51:
            next({
              name: 'login',
              query: {
                redirect: to.fullPath
              }
            }); // https://github.com/d2-projects/d2-admin/issues/138

            NProgress.done();

          case 53:
            next();
            _context.next = 57;
            break;

          case 56:
            // 不需要身份校验 直接通过想·
            next();

          case 57:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[17, 37]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function (to) {
  // 进度条
  NProgress.done(); // 多页控制 打开新的页面

  store.dispatch('d2admin/page/open', to); // 更改标题

  util.title(to.meta.title);
});
var routerArr = [];

var _import = function _import(file) {
  return function () {
    return import('@/view' + file);
  };
};

function serializationRoutesData(routes) {
  var _routes = cloneDeep(routes); // console.log('_routes',_routes);


  var arr = _routes.map(function (item) {
    var _item = {};
    _item.title = item.Menu_Name;
    _item.path = item.Link_Url;
    _item.icon = item.Icon_Url;
    _item.Target = item.Target;
    _item.title_en = item.MENU_EN;
    var path = item.Link_Url;
    var x = path.split('/');
    _item.name = x[x.length - 1];
    _item.component = _import(item.Link_Url);

    if (item.children && item.children.length > 0) {
      _item.children = serializationRoutesData(item.children);
    }

    return _item;
  });

  return arr;
}

export default router;